import {getBaseApiConfig} from '@scalified-monorepo/ng-shared/auth';
import {Interface} from './interface';

const API_URL = 'https://hono-sample-server-test.scalified.com';

export const environment: Interface = {
  production: true,
  envName: 'test',
  apiUrl: API_URL,
  appUrl: 'https://hono-sample-test.scalified.com/',
  apiConfig: getBaseApiConfig(API_URL),
};
